/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable react-perf/jsx-no-new-function-as-prop */

import { ActionIconProps, UnstyledButton } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import { forwardRef, PropsWithChildren } from "react";
import { captureException } from "@/services/log";

const POS_OLD = 1;
const POS_NEW = 3;
type CopyEmpresaInspiradoraUrlProperties = PropsWithChildren<ActionIconProps & { questionario: TQuestionario }>;

export const CopyEmpresaInspiradoraUrlButton = forwardRef<HTMLButtonElement, CopyEmpresaInspiradoraUrlProperties>(
  ({ questionario, children, ...properties }, reference) => {
    const handleClick = async () => {
      const baseUrl = window.location.host;
      const referenceParts = questionario.refPath.split("/");
      const isLicenciada = referenceParts.includes("licenciadas");
      // Se for licenciada, projetoEmpresaId está no índice 3, e licenciadaId no índice 1.
      // Caso contrário, projetoEmpresaId está no índice 1; não existe licenciadaId.
      const projetoEmpresaId = referenceParts[isLicenciada ? POS_NEW : POS_OLD];
      const licenciadaId = isLicenciada ? referenceParts[1] : undefined;
      const EmpresaInspiradoraUrl = isLicenciada
        ? `${baseUrl}/votarEmpresaInspiradora/${licenciadaId}/${projetoEmpresaId}/${questionario.id}`
        : `${baseUrl}/votarEmpresaInspiradora/${projetoEmpresaId}/${questionario.id}`;
      try {
        await navigator.clipboard.writeText(EmpresaInspiradoraUrl);
        showNotification({
          title: "Url copiada",
          message: EmpresaInspiradoraUrl,
          autoClose: 2500,
          color: "blue"
        });
      } catch (error) {
        const error_ = error as Error;
        captureException(error_, true);
        showNotification({
          message: "Não foi possível copiar a url",
          autoClose: 1000,
          color: "red"
        });
      }
    };

    return (
      <UnstyledButton ref={reference} {...properties} onClick={handleClick}>
        {children}
      </UnstyledButton>
    );
  }
);

CopyEmpresaInspiradoraUrlButton.displayName = "CopyEmpresaInspiradoraUrlButton";
